import { Box } from "@mui/material";
import { useState } from "react";

import { AppLoader, AppSnackbar } from "../../../../components/common";

import ExportDialog from "../components/ExportDialog";
import InventoryReport from "../components/InventoryReport";
import ReportInsights from "../components/ReportInsights";
import LowStockReport from "../components/LowStockReport";
import MaintenanceReport from "../components/MaintenanceReport";
import PurchaseReport from "../components/PurchaseReport";
import ReportFilters from "../components/ReportFilters";
import ReportHeader from "../components/ReportHeader";
import ReportTabs from "../components/ReportTabs";
import SpareReturnReport from "../components/SpareReturnReport";
import SupplierReport from "../components/SupplierReport";
import SummaryCards from "../components/SummaryCards";
import VehicleReport from "../components/VehicleReport";
import useReports from "../hooks/useReports";
import { ReportTab } from "../types";
import { sparePageSx } from "../../components/SparePagePresentation";

const ReportsPage = () => {
  const {
    reports,
    options,
    filters,
    loading,
    error,
    refresh,
    updateFilters,
    exportReport,
  } = useReports();
  const [exportOpen, setExportOpen] = useState(false);

  const activeTab = filters.reportTab || "inventory";

  const renderReport = (tab: ReportTab) => {
    switch (tab) {
      case "purchase":
        return <PurchaseReport rows={reports.purchaseReport} />;
      case "maintenance":
        return <MaintenanceReport rows={reports.maintenanceReport} />;
      case "supplier":
        return <SupplierReport rows={reports.supplierReport} />;
      case "vehicle":
        return <VehicleReport rows={reports.vehicleReport} />;
      case "spareReturn":
        return <SpareReturnReport rows={reports.spareReturnReport} />;
      case "lowStock":
        return <LowStockReport rows={reports.lowStockReport} />;
      case "inventory":
      default:
        return <InventoryReport rows={reports.inventoryReport} />;
    }
  };

  if (loading && !reports.inventoryReport.length) {
    return <AppLoader />;
  }

  return (
    <Box sx={sparePageSx("reports")}>
      <ReportHeader
        loading={loading}
        onRefresh={() => refresh()}
        onExport={() => setExportOpen(true)}
      />

      <ReportFilters
        filters={filters}
        options={options}
        onChange={updateFilters}
        onReset={() =>
          updateFilters({
            fromDate: "",
            toDate: "",
            warehouseId: "",
            categoryId: "",
            supplierId: "",
          })
        }
      />

      <SummaryCards summary={reports.summary} />

      <ReportInsights
        inventoryRows={reports.inventoryReport}
        purchaseRows={reports.purchaseReport}
      />

      <ReportTabs
        value={activeTab}
        onChange={(reportTab) => updateFilters({ reportTab })}
      />

      {renderReport(activeTab)}

      <ExportDialog
        open={exportOpen}
        reportTab={activeTab}
        onClose={() => setExportOpen(false)}
        onExport={(format) => exportReport(format, activeTab)}
      />

      <AppSnackbar
        open={!!error}
        severity="error"
        message={error || ""}
        onClose={() => {}}
      />
    </Box>
  );
};

export default ReportsPage;
